/* Product image lightbox — markup in snippets/rcs-lightbox.liquid */
(function () {
  function initLightbox(box) {
    if (box.dataset.rcsReady) return;
    box.dataset.rcsReady = 'true';
    var section = box.closest('[data-rcs-product]') || document;
    var gallery = section.querySelector('[data-rcs-gallery]');
    var track = box.querySelector('[data-rcs-lightbox-track]');
    var slides = Array.prototype.slice.call(track.children);
    var count = box.querySelector('[data-rcs-lightbox-count]');
    var prev = box.querySelector('[data-rcs-lightbox-prev]');
    var next = box.querySelector('[data-rcs-lightbox-next]');
    var desktop = window.matchMedia('(min-width: 990px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var opener = null;
    var isOpen = false;
    if (!gallery || !slides.length || typeof box.showModal !== 'function') return;

    function indexOf(id) {
      for (var i = 0; i < slides.length; i++) if (slides[i].dataset.mediaId === id) return i;
      return -1;
    }
    function loadNear(i) {
      [i - 1, i, i + 1].forEach(function (n) {
        var img = slides[n] && slides[n].querySelector('img');
        if (img) img.loading = 'eager';
      });
    }
    function unzoom() {
      slides.forEach(function (s) { s.classList.remove('is-zoomed'); var img = s.querySelector('img'); if (img) img.style.transformOrigin = ''; });
    }
    function update(i) {
      current = i;
      loadNear(i);
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      unzoom();
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced.matches ? 'smooth' : 'auto' });
      update(i);
    }
    function open(i) {
      opener = document.activeElement;
      box.showModal();
      document.documentElement.classList.add('rcs-lock');
      go(i, false);
      isOpen = true;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
    }
    // cleanup runs from close() rather than only the dialog 'close' event, which some
    // store scripts swallow; the event listener stays as a fallback (e.g. browser back gesture)
    function close() {
      if (box.open) box.close();
      if (!isOpen) return;
      isOpen = false;
      box.classList.remove('is-open');
      document.documentElement.classList.remove('rcs-lock');
      unzoom();
      // keep the page gallery in step with where the shopper ended up
      var target = gallery.querySelector('[data-media-id="' + slides[current].dataset.mediaId + '"]');
      if (target && !desktop.matches) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft - 16 });
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    box.addEventListener('close', close);

    /* open from the page gallery */
    gallery.addEventListener('click', function (e) {
      var img = e.target.closest('img');
      var media = img && img.closest('[data-media-id]');
      if (!media) return;
      var i = indexOf(media.dataset.mediaId);
      if (i < 0) return;
      e.preventDefault();
      open(i);
    });
    gallery.querySelectorAll('[data-media-id]').forEach(function (media) {
      if (indexOf(media.dataset.mediaId) < 0) return;
      var img = media.querySelector('img');
      if (!img) return;
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');
      img.setAttribute('aria-haspopup', 'dialog');
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(indexOf(media.dataset.mediaId)); }
      });
    });

    /* controls */
    box.querySelector('[data-rcs-lightbox-close]').addEventListener('click', close);
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1, true); }
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { unzoom(); update(i); }
      }, 60);
    }, { passive: true });

    /* click the empty area to close; click the image to zoom (desktop) */
    track.addEventListener('click', function (e) {
      var slide = e.target.closest('.rcs-lightbox__slide');
      if (!slide) return;
      if (e.target.tagName !== 'IMG') { close(); return; }
      if (!desktop.matches) return;
      var zoomed = slide.classList.toggle('is-zoomed');
      if (zoomed) pan(e, slide); else e.target.style.transformOrigin = '';
    });
    // zoom origin follows the pointer, measured against the slide so it doesn't feed back on itself
    function pan(e, slide) {
      var r = slide.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      slide.querySelector('img').style.transformOrigin = x + '% ' + y + '%';
    }
    track.addEventListener('mousemove', function (e) {
      var slide = e.target.closest('.rcs-lightbox__slide.is-zoomed');
      if (slide) pan(e, slide);
    });
  }

  function init(scope) { (scope || document).querySelectorAll('[data-rcs-lightbox]').forEach(initLightbox); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
